// import '../fake-db';
import { useRoutes, useLocation } from "react-router-dom";
import { Suspense, useEffect } from "react";
import ReactPixel from 'react-facebook-pixel';
import { PIXEL_ID } from "../config/config";
import { MatxTheme } from "./components";
import { AuthProvider } from "./contexts/JWTAuthContext";
import { SettingsProvider } from "./contexts/SettingsContext";
import { ChatProvider } from "./contexts/ChatContext";
import routes from "./routes";
import { useSelector } from "react-redux";
import { isGranded } from "./utils/compatibility"; // Using compatibility layer
import SnackBar from "./component/SnackBar";
import PageSuspense from "./components/common/PageSuspense";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const App = () => {
  const location = useLocation();

  useEffect(() => {
    if (PIXEL_ID && PIXEL_ID !== "YOUR_FACEBOOK_PIXEL_ID_HERE") {
      const options = {
        autoConfig: true,
        debug: false,
      };
      ReactPixel.init(PIXEL_ID, null, options);
    }
  }, []);

  useEffect(() => {
    if (PIXEL_ID && PIXEL_ID !== "YOUR_FACEBOOK_PIXEL_ID_HERE") {
      ReactPixel.pageView();
    }
  }, [location]);

  // Support both old and new store structure for backward compatibility
  const permissions = useSelector((state) => 
    state.permission?.permissions || state.config?.Permission || []
  );
  const { children } = routes[0];
  const filteredChildren = children.filter(
    (element) => !element.permission || isGranded(element.permission, permissions)
  );
  routes[0].children = filteredChildren;
  const content = useRoutes(routes);

  return (
    <SettingsProvider>
      <MatxTheme>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <AuthProvider>
            <ChatProvider>
              <Suspense fallback={<PageSuspense />}>
                {content}
              </Suspense>
            </ChatProvider>
          </AuthProvider>
        </LocalizationProvider>
      </MatxTheme>
      <SnackBar />
    </SettingsProvider>
  );
};

export default App;
